module.exports = __webpack_public_path__ + "static/media/send_icon.7827286b.svg";